<template>
  <div class="form-item">
    <input
      :type="type"
      class="input"
      :value="model"
      :placeholder="placeholder"
      required
      :disabled="disabled"
      @input="handleInput"
      :autocomplete="autocomplete"
    />
    <small v-if="error" class="error">{{ error }}</small>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

export default {
  name: "InputField",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    autocomplete: '',
    type: null,
    error: null
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";
.form-item {
  margin-bottom: 20px;

  .select-input {
    background: #EFEFEF;
    border-radius: 3px;
    border: none;
    width: 100%;
    padding: 10px 20px;
    height: 65px;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #727272;
  }

  input,
  .input {
    width: 100%;
    display: block;
    border-radius: 3px;
    height: 65px;
    padding: 20px;
    font-weight: bold;
    border: none;
    font-family: 'DM Sans';
    font-style: normal;
    font-size: 16px;
    color: #727272;
    background: #EFEFEF;
  }

  .error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/components/InputField.vue